export default __webpack_public_path__ + "static/media/4-duvar-tirmanisi.52a8ed6b.jpg";